import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	ViewChild
} from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { TapticEngine } from '@ionic-native/taptic-engine';
import {
	ActionSheetController,
	App,
	NavController,
	NavParams,
	Platform
} from 'ionic-angular';
import { ConfigProvider } from '../../../../providers/config/config';
import { LoaderProvider } from '../../../../providers/loader/loader';
import {
	MyPicsListModel,
	PrivateProfile,
	UserProvider
} from '../../../../providers/user/user';
import {
	PicturePagerEvent,
	PictureViewerPage
} from '../../../picture-viewer/picture-viewer';

/**
 * Generated class for the PrivateProfilePhotosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: 'page-private-profile-photos',
	templateUrl: 'private-profile-photos.html'
})
export class PrivateProfilePhotosPage {
	pictures: MyPicsListModel[] = [];
	activeIndex?: number = null;
	profile: PrivateProfile;

	@ViewChild('uploadButton')
	uploadButton: any;
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private userService: UserProvider,
		private actionSCtrl: ActionSheetController,
		private loadingCtrl: LoaderProvider,
		private camera: Camera,
		private app: App,
		private changeDetector: ChangeDetectorRef,
		public translate: TranslateService,
		private config: ConfigProvider,
		private taptic: TapticEngine,
		private platform: Platform
	) {
		this.profile = navParams.data.data.profile;
		this.pictures = navParams.data.data.pictures;
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad PrivateProfilePhotosPage');
		this.createFileInput();
	}

	open(picture, index) {
		console.log('tap', picture);

		let emitter = new EventEmitter();
		emitter.subscribe(event => {
			this.pictureRotated(event);
		});
		(this.app.getRootNav() as NavController).push(PictureViewerPage, {
			emitter: emitter,
			pictures: this.pictures,
			activeIndex: index,
			icon: 'refresh',
			icon1: 'trash'
		});
	}

	async pictureRotated(event: PicturePagerEvent) {
		let loader = this.loadingCtrl.create({ content: 'loading' });
		await loader.present();
		let model = event.list[event.index];

		let base64ImageSrc = model.imageLink;
		let that = this;
		let img = new Image();
		img.setAttribute('crossOrigin', 'anonymous');

		img.onload = async () => {
			let c = document.createElement('canvas');
			c.width = img.height;
			c.height = img.width;
			let ctx = c.getContext('2d');
			ctx.rotate((90 * Math.PI) / 180);
			ctx.drawImage(img, 0, -img.height);
			let base = c.toDataURL();

			if (base.length > 6) {
				let photo = await that.userService.createPhoto(model.id, base, false);
				that.userService.removePhoto(model.id);
				event.list[event.index] = photo as any;
				that.changeDetector.markForCheck();
				that.changeDetector.detectChanges();
			}
			loader.dismiss();
		};
		img.src = base64ImageSrc;
	}

	picPress(picture, index) {
		console.log('press', picture);
		let sheet = this.actionSCtrl.create({
			title: this.translate.instant('GLOBAL_OPTIONS'),
			buttons: [
				{
					text: 'Open',
					handler: () => {
						this.open(picture, index);
					}
				},
				{
					text: 'Delete',
					role: 'destructive',
					handler: () => {
						this.removePicture(picture);
					}
				},
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {
						console.log('Cancel clicked');
					}
				}
			]
		});
		if (window['TapticEngine'] && this.platform.is('ios')) {
			this.taptic.selection();
		}
		sheet.present();
	}

	removePicture(picture: MyPicsListModel) {
		console.log('delete', picture);
		let loader = this.loadingCtrl.create({ content: 'loading' });
		loader.present();
		this.userService.removePhoto(picture.id).then(success => {
			if (success) {
				this.pictures = this.pictures.filter(x => x.id !== picture.id);
			}
			loader.dismiss();
		});
	}

	addNewPicture(data) {
		let loader = this.loadingCtrl.create({ content: 'loading' });
		loader.present();
		this.userService.createPhoto(-1, data, false).then(data => {
			this.pictures.push(data as any);
			loader.dismiss();
		});
	}
	fileInputClick() {
		const options: CameraOptions = {
			quality: 100,
			destinationType: this.camera.DestinationType.DATA_URL,
			encodingType: this.camera.EncodingType.JPEG,
			mediaType: this.camera.MediaType.PICTURE,
			sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
			correctOrientation: true
		};
		this.camera
			.getPicture(options)
			.then(photo => {
				this.addNewPicture('data:image/jpeg;base64,' + photo);
			})
			.catch();
	}

	async createFileInput() {
		if (!(await this.config.config).platform.browser) return;
		if (document.querySelector('.cordova-camera-select')) return;
		try {
			const options: CameraOptions = {
				quality: 100,
				destinationType: this.camera.DestinationType.DATA_URL,
				encodingType: this.camera.EncodingType.JPEG,
				mediaType: this.camera.MediaType.PICTURE,
				sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
				correctOrientation: true
			};
			this.camera
				.getPicture(options)
				.then(photo => {
					this.addNewPicture('data:image/jpeg;base64,' + photo);
					// this.createFileInput();
				})
				.catch();
			var input = document.querySelector(
				'.cordova-camera-select'
			) as HTMLElement;
			document.body.removeChild(input);
			console.log(this.uploadButton);
			input.style.opacity = 0 + '';
			input.style.position = 'fixed';
			input.style.height = '100%';
			console.log(this.uploadButton);
			let button = this.uploadButton.getNativeElement() as HTMLElement;
			button.parentElement.insertBefore(input, button);
		} catch {
			//this.model.img = "data:image/png;base64,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";
		}
	}

	select(photo) {
		this.profile.profilePicLink = photo.imageLink;
		this.app.getRootNav().pop();
	}
}



// WEBPACK FOOTER //
// /src/pages/me/settings/private-profile-photos/private-profile-photos.ts